import { KeyValue } from '../common/redux/api/web-api'

const findOcppConfig = (key: string, ocppConfigKeys: KeyValue[] | undefined | null): string | null => {
    if (!ocppConfigKeys || !ocppConfigKeys.length) {
        return null
    }
    return ocppConfigKeys?.find((x) => x.key === key)?.value
}

export default findOcppConfig
